import CortanaComposeViewState from '../store/schema/CortanaComposeViewState';
import PluginCallbacks from '../store/schema/PluginCallbacks';
import { ObservableMap } from 'mobx';
import CortanaComposeResult, {
    CortanaComposeResultSection,
} from '../store/schema/CortanaComposeResult';

export default function createCortanaComposeViewState(
    pluginCallbacks: PluginCallbacks
): CortanaComposeViewState {
    return {
        queryString: '',
        wordBeforeCursor: '',
        isSuggesting: false,
        isPopupShown: false,

        selectedIndexInSection: 0,
        selectedSectionIndex: 0,

        resultsShown: new ObservableMap<string, CortanaComposeResult[]>([
            [CortanaComposeResultSection.smartReply, []],
            [CortanaComposeResultSection.document, []],
            [CortanaComposeResultSection.dorado, []],
        ]),
        flexPaneResults: [],
        flexPaneResultsLoading: false,
        hasSelectableElement: false,

        pluginCallbacks: pluginCallbacks,
    };
}

export { ObservableMap };
